import React from 'react';

const DateRangePicker = ({ onRangeChange, initialRange }) => {
    const [startDate, setStartDate] = React.useState(initialRange.startDate || '');
    const [endDate, setEndDate] = React.useState(initialRange.endDate || '');

    const handleDateChange = () => {
        if (startDate && endDate) {
            onRangeChange({ 
                startDate: new Date(startDate), 
                endDate: new Date(endDate) 
            });
        }
    };

    return (
        <div className="flex items-center space-x-2">
            <div className="relative">
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    onBlur={handleDateChange}
                    className="block w-full rounded-md border-gray-300 shadow-sm 
                              focus:border-teal-500 focus:ring-teal-500 sm:text-sm py-2 px-3"
                />
            </div>
            <span className="text-gray-500">to</span>
            <div className="relative">
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    onBlur={handleDateChange}
                    min={startDate}
                    className="block w-full rounded-md border-gray-300 shadow-sm 
                              focus:border-teal-500 focus:ring-teal-500 sm:text-sm py-2 px-3"
                />
            </div>
        </div>
    );
};



export default DateRangePicker;